import * as React from 'react';
import { ArticleHeading4 } from '@cian/ui-kit';

import { NewbuildingImage } from './parts/NewbuildingImage';
import { Field } from '../../common';
import { Link } from '../../../Link';

interface INewbuildingInfoProps {
  imageUrl: string;
  name: string;
  url: string;
  onClick?(e?: React.MouseEvent<HTMLAnchorElement>): void;
}

export const NewbuildingField: React.FC<INewbuildingInfoProps> = ({ imageUrl, name, url, onClick }) => {
  return (
    <Field>
      <Link href={url} target="_blank" onClick={onClick}>
        <NewbuildingImage url={imageUrl} name={name} />
        <ArticleHeading4 color="primary_100">{name}</ArticleHeading4>
      </Link>
    </Field>
  );
};
